//画面サイズごとの処理
$(window).on('load resize', function(){
	const w = $(window).width();
	deviceFunc(w);
});

const browser=browserCheck();
const os=osCheck();
const device=deviceCheck();
$("body").addClass(browser).addClass(os);

const href=$(location).attr('href');
let host=	$(location).attr('hostname');
const ref=document.referrer;
const hash=$(location).attr('hash');

if(href.indexOf("/test/")>0)	{
	host=host + "/test";
}

$(document).ready(function(){
	
	//Lazyload
	//<img src="common/images/preloader.png" data-src="xxxx.jpg" loading="lazy" class="lazyload"/>
	/*if ("loading" in HTMLImageElement.prototype) {
		var images = document.querySelectorAll('img[loading="lazy"]');
		images.forEach(function (img) {
			img.src = img.dataset.src;
		});
	} else {
		var script = document.createElement("script");
		script.src = "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.1.8/lazysizes.min.js";
		document.body.appendChild(script);
	}*/
	
  // <a href="#***">の場合、スクロール処理を追加
  $('a[href*="#"]').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  		let $target = jQuery(this.hash);
      $target = $target.length && $target || jQuery('[name="' + this.hash.slice(1) +'"]');
      if ($target.length) {
      	const targetOffset = $target.offset().top;
        if($(this).parents(".menu-open").length){
					$("body").toggleClass("menu-open");
				}
				$('html,body').animate({ scrollTop: targetOffset }, 800, 'easeOutExpo');//fast
        return false;
      }
    }
  });
  
  //Menu
  $("#menu-btn").on("click",function(){
	  $("body").toggleClass("menu-open");
  });
  
  if($('.datepicker').length){
		$('.datepicker').datepicker(
			{
				dateFormat: 'yy年mm月dd日',
			}
		);
	}

	$("#relation").on("change",function(){
		if($(this).val()=="その他"){
			$(".relation-other").slideToggle(200);
		}else{
			$(".relation-other").slideUp(200);
		}
	});
	$("#prefecture").on("change",function(){
		if($(this).val()=="その他"){
			$(".pref-other").slideToggle(200);
		}else{
			$(".pref-other").slideUp(200);
		}
	});
	$("#prefecture2").on("change",function(){
		if($(this).val()=="その他"){
			$(".pref-other2").slideToggle(200);
		}else{
			$(".pref-other2").slideUp(200);
		}
	})

	

	$(".qa-hidden").on("click",function(){
		var speed = 1000;
		if($(this).hasClass("qa-open")){
			$(".qa-hidden-btn",this).text("その他のQ&Aはこちら");
			speed = 500;
		}else{
			$(".qa-hidden-btn",this).text("その他のQ&Aを閉じる");
		}
		$(this).toggleClass("qa-open");
		$(".qa-hidden-box").slideToggle(speed);
		
	});


  //inView
  $('.anm').on('inview', function(event, isInView) {
    if (isInView) {
    //表示領域に入った時
      $(this).addClass('is-show');
    } else {
    //表示領域から出た時
     	//$(this).removeClass('is-show');
    }
  });
  
  
  //scroll
  $(window).scroll(function () {
   	const body = window.document.body;
	 	const html = window.document.documentElement;
	 	const scrTop = body.scrollTop || html.scrollTop;
	 	const scrBottom = html.scrollHeight - html.clientHeight - scrTop;
	 	if(scrTop > 300){
			
		}
		if(scrBottom <= 200){
			$(".fixed-cv-sp").addClass("hide");
		}else{
			$(".fixed-cv-sp").removeClass("hide");
		}
  });
  
  
  if($(".form-validation").length){
		$.extend( $.validator.messages, {
			required:'入力してください',
			email:'正しいメールアドレスの形式を入力してください',
		});

		const validation = $(".form-validation").validate({
			rules: {
				family_name: {
					required:true,
				},
				given_name: {
					required:true,
				},
				family_name_kana: {
					required:true,
				},
				given_name_kana: {
					required:true,
				},
				prefecture: {
					required:true,
				},
				tel:{
					required:true,
				},
				email:{
					required:true,
					email:true,
				},
				ckemail:{
					required: true,
					equalTo: '#email',
				},
				date:{
					required: true,
				}
				/*meeting_date1:{
					required: true,
				}*/
			},
			messages:{
				ckemail:{
					required:'確認用のメールアドレスを入力してください',
					equalTo:'確認用メールアドレスが異なります',
				}
			},
		});

	}
	if($(".form-mailmag-validation").length){
		$.extend( $.validator.messages, {
			required: '入力してください',
			email:'正しいメールアドレスの形式を入力してください',
		});

		const mail_validation = $(".form-mailmag-validation").validate({
			rules: {
				email:{
					required:true,email:true,
				}
			},
			errorPlacement: function(error, element){
				error.insertAfter(element);
			},
		});
	}
	
});

function deviceFunc(w){
	const bp = [767,999,1280];
	if(w > bp[1]){ //タブレット以上（PC）

  }else{ //タブレット以下
	
  }
  if (w > bp[0]){//スマートフォン以上
	  $(".tel-wrap .tel-number").each(function(){
			$(this).unwrap();
		});
  }else{ //スマートフォン以下
	 	$(".tel-number").each(function(){
			if(!$(this).parent(".tel-wrap").length){
				const no = $(this).data("tel");
				$(this).wrap('<a href="tel:' + no + '" class="tel-wrap"></a>');
			}
		});
		
  }
}


/*ブラウザ判別*/
function browserCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	const av = window.navigator.appVersion.toLowerCase();
	if(ua.indexOf('edge') != -1){
		return 'edge';
	}else if (ua.indexOf('opera') != -1) {
  	return 'opera';
	}else if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
		$("body").addClass('ie');
  	if (av.indexOf("msie 6.") != -1) {
    	return 'ie6';
  	} else if (av.indexOf("msie 7.") != -1) {
    	return 'ie7';
  	} else if (av.indexOf("msie 8.") != -1) {
    	return 'ie8';
  	} else if (av.indexOf("msie 9.") != -1) {
    	return 'ie9';
  	}else if (av.indexOf("msie 10.") != -1) {
    	return 'ie10';
  	}else if (av.indexOf("rv:11.") != -1) {
    	return 'ie11';
  	}
	} else if (ua.indexOf('chrome') != -1) {
  	return 'chrome';
	} else if (ua.indexOf('safari') != -1) {
  	return 'safari';
	} else if (ua.indexOf('gecko') != -1) {
  	return 'firefox';
	} else {
  	return false;
	}
}

/*OS判別*/
function osCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('windows') != -1) {
		if(ua.indexOf('phone') != -1){
			return 'winphone';
		}else{
			return 'win';
		}
	}else if(ua.indexOf('iphone') != -1) {
		return 'iphone';
	}else if(ua.indexOf('ipad') != -1) {
		return 'ipad';
	}else if(ua.indexOf('mac') != -1) {
		return 'mac';
	}else if(ua.indexOf('android') != -1) {
		if(ua.indexOf('mobile') != -1){
			if(ua.indexOf('A1_07') != -1){
				return 'tablet';
			}else if(ua.indexOf('SC-01C') != -1){
				return 'tablet';
			}else{	return 'android';}
		}else{
			return 'tablet';
		}
	}else{
		return false;
	}
}

/*デバイス判別*/
function deviceCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if((ua.indexOf("windows") != -1 && ua.indexOf("touch") != -1 && ua.indexOf("tablet pc") == -1) 
      || ua.indexOf("ipad") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") == -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("tablet") != -1)
      || ua.indexOf("kindle") != -1
      || ua.indexOf("silk") != -1
      || ua.indexOf("playbook") != -1){
      return 'tab';
    }else if((ua.indexOf("windows") != -1 && ua.indexOf("phone") != -1)
      || ua.indexOf("iphone") != -1
      || ua.indexOf("ipod") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") != -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("mobile") != -1)
      || ua.indexOf("blackberry") != -1){
	    return 'sp';
    }else{
      return 'pc';
    }
}


